import React from "react";
import { useLocation, Switch, Route } from "react-router-dom";
import { useSeo } from "../../hooks";

import VerifyEmail from "../Home/VerifyEmail";
import HomeLogin from "../Home/HomeLogin";
import RecoverPassword from "../Home/RecoverPassword";
import ResetPassword from "../Home/ResetPassword";
import Announcements from "../../components/Home/Announcements";

const NewsPage: React.FC<{}> = () => {
    const location = useLocation();

    useSeo({
        title: "Oberin News - Announcements and Updates",
        description:
            "Stay up to date with the latest Oberin announcements, Real Time Quest recaps, game updates, and community news.",
        canonical: "https://www.oberin.be/news",
        robots: "index,follow",
        ogImage: "https://www.oberin.be/logo512.png",
        twitterCard: "summary_large_image",
    });

    return (
        <React.Fragment>
            <Switch>
                <Route path="/news/verifyEmail">
                    <VerifyEmail pathname={location.pathname} />
                </Route>
                <Route path="/news/login">
                    <HomeLogin />
                </Route>
                <Route path="/news/recoverPassword">
                    <RecoverPassword />
                </Route>
                <Route path="/news/resetPassword">
                    <ResetPassword />
                </Route>
            </Switch>

            <h1 className="sr-only">Oberin News and Announcements</h1>

            {/* Announcements */}
            <Announcements />
        </React.Fragment>
    );
};

export default NewsPage;
